/**
 * 贴地图前处理（轻量）：仅居中 + 按正射范围对齐尺度。
 * 断裂区域剔除应在「开算前选片/框选 AOI」完成，勿在 GLB 上猜主簇（易误删村庄）。
 */
import * as THREE from 'three';

/**
 * @param {THREE.Object3D} model
 * @param {{ targetMeters?: number }} opts
 */
export function prepareModelForMapAttach(model, { targetMeters = 80 } = {}) {
  model.updateMatrixWorld(true);
  const box = new THREE.Box3().setFromObject(model);
  if (box.isEmpty()) throw new Error('模型包围盒为空');

  const center = box.getCenter(new THREE.Vector3());
  const size = box.getSize(new THREE.Vector3());
  const maxDim = Math.max(size.x, size.y, size.z) || 1;
  model.position.sub(center);

  const target = Number(targetMeters) > 0 ? Number(targetMeters) : 80;
  // 仅当与图层范围差很多时微调，避免乱缩放；根治靠开算前框选村庄
  let fit = 1;
  if (maxDim > target * 3 || maxDim < target * 0.2) {
    fit = target / maxDim;
    model.scale.multiplyScalar(fit);
  }

  return {
    removed: 0,
    droppedTris: 0,
    keptTris: 0,
    kept: 1,
    robustMaxDim: maxDim,
    cullRadius: 0,
    fit,
    sizeX: size.x * fit,
    sizeY: size.y * fit,
    sizeZ: size.z * fit,
    targetMeters: target,
    clusterMethod: 'none',
    note: '断裂剔除请在开算前框选渲染区'
  };
}
